module.exports = __webpack_public_path__ + "static/img/image2.3af6f75.jpg";